import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=54cbf9ee&scoped=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=54cbf9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbf9ee",
  null
  
)

export default component.exports